import { useSearchParamsState } from 'hooks/useSearchParamState';
import { useStore } from 'hooks/useStore';
import { AutoComplete } from 'primereact/autocomplete';
import { useEffect, useRef } from 'react';

export const useConceptSearchBar = () => {
  const {
    MSPlanStore: {
      handleFetchAllConceptDetailsForSearch,
      handleFetchAllDetailsByGFC,
      conceptDetails,
      isConceptDetailsLoading,
      isAllConceptLoading,
      filteredConceptsForSearch,
      handleFilterConceptSearch,
      handleConceptSearchInputChange,
      handleEnterKeyDownConceptSearchField,
      handleSearch,
      conceptSearchInput,
    },
  } = useStore();
  const isSearchButtonDisabled = () => {
    return conceptDetails ? false : true;
  };
  const [gfcParam, setGfcParam] = useSearchParamsState('gfc', '');

  const serchfieldRef = useRef<AutoComplete>(null);

  useEffect(() => {
    serchfieldRef.current?.focus();
    handleFetchAllConceptDetailsForSearch();
  }, [handleFetchAllConceptDetailsForSearch]);

  useEffect(() => {
    serchfieldRef.current?.focus();
    if (gfcParam) {
      handleFetchAllDetailsByGFC(gfcParam);
    } else {
      handleFetchAllConceptDetailsForSearch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (conceptDetails && conceptDetails.gfc) setGfcParam(conceptDetails.gfc.toString());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conceptDetails]);

  return {
    // handleFetchAllConceptDetailsForSearch,
    isSearchButtonDisabled,
    conceptDetails,
    serchfieldRef,
    isConceptDetailsLoading,
    isAllConceptLoading,
    filteredConceptsForSearch,
    handleFilterConceptSearch,
    handleConceptSearchInputChange,
    handleEnterKeyDownConceptSearchField,
    handleSearch,
    conceptSearchInput,
  };
};
